import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  BrowserRouter,
  useLocation
} from "react-router-dom";
import "./App.css";
import "./App-fx.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-circular-progressbar/dist/styles.css";
import { useAuth } from "./context/contextAuth";
import { useProfile } from "./context/contextProfile";
import { useDesign } from "./context/contextDesign";
import { useThemeMode } from "./context/contextTheme";
import useDeviceDetect from "./utils/deviceDetect";
import Main from "./pages/main";
import SignIn from "./pages/signin";
import SignUp from "./pages/signup";
// import SignUpToken from "./pages/signup-token";
import SignInAdmin from "./pages/admin";
// import AdminEmailDispatcher from "./pages/admin/mail";
// import AdminSignIn from "./pages/admin/signin";
import Demo from "./pages/demo";
// import MeetingScheduled from "./pages/meeting-scheduled";
import Reset from "./pages/reset";
import ResetPass from "./pages/resetPass";
import MFA from "./pages/mfa";
import PrivacyPolicy from "./pages/__PrivacyPolicy";
import TermsConditions from "./pages/__TermsConditions";
import RefundPolicy from "./pages/__RefundPolicy";
import Shipping from "./pages/__Shipping";
import AboutUs from "./pages/__AboutUs";
import { ContactUs } from "./pages/__ContactUs";
import Test from "./pages/test";

function App() {
  const {
    user,
    sign2fa,
    meetScheduled,
    validateSession,
  } = useAuth();
  const { theme, mode } = useThemeMode();
  const { setSidebarExtended } = useProfile();
  const { zoom, setZoom } = useDesign();
  const {
    isMobile,
    isTablet,
    isDesktop,
    isMidDesktop,
    isLargeDesktop
  } = useDeviceDetect();

  const TrackPageViews = () => {
    const location = useLocation();
    useEffect(() => {
      if (window.gtag) {
        window.gtag('config', 'G-BTNW8QBWNY', {
          page_path: location.pathname,
        });
      }
    }, [location]);
    return null;
  };

  useEffect(() => {
    if (isMobile || isTablet || isDesktop || isMidDesktop) {
      setSidebarExtended(false);
    } else {
      setSidebarExtended(true);
    }
  }, [isMobile, isTablet, isDesktop, isMidDesktop, setSidebarExtended]);

  useEffect(() => {
    if (isMobile) {
      setZoom(1);
    } else if (isTablet) {
      setZoom(0.8);
    } else if (isMidDesktop) {
      setZoom(0.86);
    } else if (isDesktop) {
      setZoom(0.9);
    } else if (isLargeDesktop) {
      setZoom(1);
    }
  }, [isMobile, isTablet, isDesktop, isMidDesktop, isLargeDesktop]);

  useEffect(() => {
    validateSession();
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return undefined;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BTNW8QBWNY';
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };

    window.gtag('js', new Date());
    window.gtag('config', 'G-BTNW8QBWNY');

    return () => {
      script.remove();
    };
  }, []);

  return (
    <BrowserRouter basename="/save">
      <TrackPageViews />
      <div className="App">
        {!user ? (
          <Routes>
            <Route path="/admin" element={<SignInAdmin />} />
            <Route path="/demo" element={<Demo />} />

            <Route path="/" element={<SignIn />} />
            <Route path="/signin" element={<SignIn />} />
            {/* <Route path="/signup" element={<SignUpToken />} /> */}
            <Route path="/signup/:uuid" element={<SignUp />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="/:userId/reset-password" element={<ResetPass />} />
            <Route path="/mfa" element={sign2fa ? <MFA /> : <Navigate to="/signin" replace />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/test" element={<Test />} />
            <Route path="/*" element={<Navigate to="/" />} />
          </Routes>
        ) : (
          <Main />
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
